<div class="container-fluid mt-2 mb-2">
    <div class="row mt-2">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row">
        <div class="col">
            <h2>Edit Payment Method</h2>
        </div>
    </div>
    <div class="row mt-2">
        <div class="container-fluid">
            <div class="row">
                <h3 class="mat-h3">Billing Information</h3>
            </div>
            <form [formGroup]="billingForm" class="row">
                <div class="col-4">
                    <mat-form-field>
                        <input matInput type="text" id="firstName" name="firstName" placeholder="First Name"
                            formControlName="firstName">
                        <mat-error *ngIf="billingForm.get('firstName').errors?.required">First Name is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('firstName').errors?.validationErrors">
                            {{ billingForm.get("firstName").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <input matInput type="text" id="lastName" name="lastName" placeholder="Last Name"
                            formControlName="lastName">
                        <mat-error *ngIf="billingForm.get('lastName').errors?.required">Last Name is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('lastName').errors?.validationErrors">
                            {{ billingForm.get("lastName").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <input matInput type="text" id="email" name="email" placeholder="Email" formControlName="email">
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="city" name="city" placeholder="City" formControlName="city">
                        <mat-error *ngIf="billingForm.get('city').errors?.required">City is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('city').errors?.validationErrors">
                            {{ billingForm.get("city").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="state" name="state" placeholder="State" formControlName="state">
                        <mat-error *ngIf="billingForm.get('state').errors?.required">State is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('state').errors?.validationErrors">
                            {{ billingForm.get("state").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="country" name="country" placeholder="Country"
                            formControlName="country">
                        <mat-error *ngIf="billingForm.get('country').errors?.required">Country is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('country').errors?.validationErrors">
                            {{ billingForm.get("country").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="postalCode" name="postalCode" placeholder="Zip Code"
                            formControlName="postalCode">
                        <mat-error *ngIf="billingForm.get('postalCode').errors?.required">Zip Code is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('postalCode').errors?.validationErrors">
                            {{ billingForm.get("postalCode").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field>
                        <input matInput type="text" id="address1" name="address1" placeholder="Address 1"
                            formControlName="address1">
                        <mat-error *ngIf="billingForm.get('address1').errors?.required">Address 1 is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('address1').errors?.validationErrors">
                            {{ billingForm.get("address1").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field>
                        <input matInput type="text" id="address2" name="address2" placeholder="Address 2"
                            formControlName="address2">
                    </mat-form-field>
                </div>
            </form>
            <div class="row">
                <div class="col">
                    <section class="align-content-center">
                        <mat-checkbox [(ngModel)]="defaultPaymentMethod">Default</mat-checkbox>
                    </section>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-2">
            <button mat-raised-button [disabled]="isLoading" (click)="updatePayment()">Save</button>
        </div>
        <div class="col-3">
            <button mat-raised-button color="warn" (click)="dialogRef.close()" [disabled]="isLoading">Cancel</button>
        </div>
    </div>
</div>